import React from 'react';
import TravelOptionsCard from './navigation/TravelOptionsCard';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import './ChatMessage.css';
import KtmbTimetableCard from './ktmb/KtmbTimetableCard';

const ChatMessage = ({ 
  sender, 
  text, 
  loading, 
  travelFrom, 
  travelTo, 
  travelOptions,
  showOverlay,
  setShowOverlay,
  showMapOverlay,
  setShowMapOverlay,
  showBlogOverlay,
  setShowBlogOverlay,
  ktmbTimetable,
  departureTime,
  hasImpreziaAd,
}) => {
  const isUser = sender === 'user';

  return (
    <>
    {/* <p>ktmbTimetable: {ktmbTimetable}</p> */}
      {/* ✅ Render carousel only if this bot message requests it */}
      <div className={`message-row ${isUser ? 'user' : 'bot'}`}>
        <div
          className={`message-bubble ${isUser ? 'user' : 'bot'}`}
        >
          {loading ? (
            <div className="message-loading">
              <div className="message-loading-dot" style={{ animationDelay: '0s' }}></div>
              <div className="message-loading-dot" style={{ animationDelay: '0.2s' }}></div>
              <div className="message-loading-dot" style={{ animationDelay: '0.4s' }}></div>
            </div>
          ) : travelOptions ? (
            <>
              <div className="message-text">
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeRaw]}
                  components={{
                    p: ({ node, ...props }) => <p style={{ margin: 0 }} {...props} />,
                    h1: ({ node, ...props }) => <h1 style={{ margin: 0, fontSize: '1.2rem' }} {...props} />,
                    h2: ({ node, ...props }) => <h2 style={{ margin: 0, fontSize: '1.1rem' }} {...props} />,
                    h3: ({ node, ...props }) => <h3 style={{ margin: 0, fontSize: '1rem' }} {...props} />,
                    a: ({ node, href, children, ...props }) => (
                      <a 
                        href={href} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ color: '#007bff', textDecoration: 'underline' }}
                        {...props}
                      >
                        {children}
                      </a>
                    )
                  }}
                >
                  {text}
                </ReactMarkdown>
              </div>
              <TravelOptionsCard
                options={travelOptions}
                from={travelFrom}
                to={travelTo}
                showOverlay={showOverlay}
                setShowOverlay={setShowOverlay}
                showMapOverlay={showMapOverlay}
                setShowMapOverlay={setShowMapOverlay}
                showBlogOverlay={showBlogOverlay}
                setShowBlogOverlay={setShowBlogOverlay}
              />
            </>
          ) : ktmbTimetable ? (
            <div className="message-text">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
                components={{
                  p: ({ node, ...props }) => <p style={{ margin: 0 }} {...props} />,
                  h1: ({ node, ...props }) => <h1 style={{ margin: 0, fontSize: '1.2rem' }} {...props} />,
                  h2: ({ node, ...props }) => <h2 style={{ margin: 0, fontSize: '1.1rem' }} {...props} />,
                  h3: ({ node, ...props }) => <h3 style={{ margin: 0, fontSize: '1rem' }} {...props} />,
                  a: ({ node, href, children, ...props }) => (
                    <a 
                      href={href} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ color: '#007bff', textDecoration: 'underline' }}
                      {...props}
                    >
                      {children}
                    </a>
                  )
                }}
              >
                {text}
              </ReactMarkdown>
              <KtmbTimetableCard
                from={travelFrom}
                to={travelTo}
                timetable={ktmbTimetable}
                departureTime={departureTime}
              />
            </div>
          ) : (
            <div className="message-text">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
                components={{
                  p: ({ node, ...props }) => <p style={{ margin: 0 }} {...props} />,
                  h1: ({ node, ...props }) => <h1 style={{ margin: 0, fontSize: '1.2rem' }} {...props} />,
                  h2: ({ node, ...props }) => <h2 style={{ margin: 0, fontSize: '1.1rem' }} {...props} />,
                  h3: ({ node, ...props }) => <h3 style={{ margin: 0, fontSize: '1rem' }} {...props} />,
                  a: ({ node, href, children, ...props }) => {
                    return (
                      <a 
                        href={href} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ color: '#007bff', textDecoration: 'underline' }}
                        {...props}
                      >
                        {children}
                      </a>
                    );
                  }
                }}
              >
                {text}
              </ReactMarkdown>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ChatMessage;
